import { useState, useEffect } from 'react';
import { useApi, githubAuthApiRef } from '@backstage/core-plugin-api';
import { fetchTeams, GithubTeam } from './githubApi';

interface UseGithubTeamsResult {
  teams: GithubTeam[];
  loading: boolean;
  error: string | null;
}

export function useGithubTeams(
  owner: string,
  pattern?: string,
): UseGithubTeamsResult {
  const [teams, setTeams] = useState<GithubTeam[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const githubAuth = useApi(githubAuthApiRef);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = await githubAuth.getAccessToken(['read:org']);
        const result = await fetchTeams(token, owner, pattern);
        setTeams(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch teams');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [githubAuth, owner, pattern]);

  return { teams, loading, error };
}
